import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const LoginFormConfig = (t) => Yup.object().shape({
  login_name: Yup.string().required(t("pages.login_page.alerts.please_enter_the_username")).trim(),
  password: Yup.string().required(t("pages.login_page.alerts.please_enter_the_password")).trim(),
});

export default LoginFormConfig;
